/* global document */
import { useEffect } from 'react';

const PayGateHiddenForm = (props) => {
  const { redirect } = props;
  useEffect(() => {
    document.getElementById('payGate').submit();
  }, []);

  return (
    <form method="post" action={redirect.url} id="payGate">
      {redirect.formValues.map((entity) => (
        <input
          type="hidden"
          key={entity.key}
          name={entity.key}
          value={entity.value}
        />
      ))}
    </form>
  );
};

export default PayGateHiddenForm;
